import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";

import Autocomplete from "@mui/material/Autocomplete";
import classnames from "classnames";
import { actions as advActions } from "components/advertising/logic/formActions";
import _, { get } from "lodash";
import { connect } from "react-redux";
import envconfig from "../../../envconfig";
import "./styles.scss";
import {DATE_FORMAT_ONLY_YEAR, formatDate} from "components/common/dateUtils";

const FilmReleaseAutocomplete = ({ filmTitles, loadFilmTitles, onChange, placeholder, defaultValue, isForm, ...props }) => {


    const [inputValue, setInputValue] = useState(defaultValue);

    useEffect(() => {
        if (!inputValue) setInputValue(defaultValue);
    }, [defaultValue, inputValue]);

    const getFilmByTitle = _.debounce(props.getFilmByTitle, 300);

    const formatOptionLabel = (ev, option) => {
        return (
            <div className="option-wrapper" onMouseDown={() => _onChange(ev, option)}>
                <div className="option-label" style={{ display: "flex", flex: 1, fontSize: 14, fontWeight: 500 }}>
                    {option.label}
                </div>

                <div style={{ display: "flex", flex: 1 }}>
                    <React.Fragment>
                        <div style={{ display: "flex", flex: "6", opacity: 0.6 }}>{option.company}</div>
                        <div style={{ display: "flex", flex: "1", opacity: 0.6 }}>{option.ratingType}</div>
                        <div style={{ display: "flex", flex: "1", opacity: 0.6 }}>{option.releaseType}</div>
                        <div style={{ display: "flex", flex: "1", opacity: 0.6 }}>{option.relDate}</div>
                    </React.Fragment>
                </div>
            </div>
        );
    };

    const onInput = (e) => {
        setInputValue(e.target.value);
        if (e.target.value.length > envconfig.MAX_CHARACTERS_SEARCH_INPUT || isForm) {
            onChange(e.target.value);
            getFilmByTitle({
                titlePattern: e.target.value,
            });
        }
    };

    const onKeyDown = (e) => {
        if (e.keyCode === 13) {
            getFilmByTitle({
                titlePattern: this.state.filmValue,
            });
        }
    };

    const _onChange = (_, value) => {
        setInputValue(value ? value.label : "");
        onChange(value);
    };

    const filmTls = filmTitles.map((fTitle) => ({
        value: fTitle.id,
        label: fTitle.title,
        company: fTitle.companyId.title,
        ratingType: get(fTitle, "filmRatingTypeId.abbreviation", ""),
        releaseType: get(fTitle, "filmReleaseTypeId.abbreviation", ""),
        relDate: fTitle.releaseDate
            ? formatDate(fTitle.releaseDate, DATE_FORMAT_ONLY_YEAR)
            : formatDate(fTitle.enteredDate, DATE_FORMAT_ONLY_YEAR),
        ...fTitle,
    }));

    return (
        <Autocomplete
            className={classnames("film-release-autocomplete", props.className)}
            freeSolo
            inputValue={inputValue || ""}
            options={filmTls}
            onChange={_onChange}
            loading={loadFilmTitles === "SEND"}
            getOptionLabel={(option) => option.label}
            renderInput={(params) => {
                return (
                    <TextField
                        className="form-control"
                        {...params}
                        placeholder={placeholder || "Enter or select film title"}
                        margin="normal"
                        variant="outlined"
                        onChange={onInput}
                        onKeyDown={onKeyDown}
                    />
                );
            }}
            renderOption={formatOptionLabel}
        />
    );
};

const mapStateToProps = ({ advertising: { filmTitles, loadFilmTitles } }) => ({
    filmTitles,
    loadFilmTitles,
});

const mapDispatchToProps = (dispatch) => ({
    getFilmByTitle: (payload) => dispatch(advActions.GET_FILM_TITLE.send(payload)),
});



export default connect(mapStateToProps, mapDispatchToProps)(FilmReleaseAutocomplete);
